import SigniteButton from '../../../ui-elements/signite-button/signiteButton';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import './addClient.css';
import { forwardRef, useEffect, useRef, useState } from 'react';
import Loader from 'react-spinner-loader';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { first } from 'lodash';
import { getErrorClass, getErrorMessage } from '../../../../utils/errorUtils';
import { handleClientSubmission, handleClientFileChange, handlePinChange } from './clientSubmissionHandler';
import { MasterDataService } from '../../../../services/masterDataService';
import { AddClientFormValidationSchema } from '../../admin-candidate/validations/admin-forms/addClientFormValidationSchema';
import { ClientService } from '../../../../services/clientService';
import ClientUserService from '../../../../services/client-services/clientUserService';
import { useSearchParams } from 'react-router-dom';
import ReactDatePicker from 'react-datepicker';
import { Modal } from 'react-bootstrap';
import { Formik, Form as FormikForm, Field, FieldArray, ErrorMessage, useFormikContext } from "formik";
import { Form as BSForm } from 'react-bootstrap';
import { Tabs, Tab, Button } from 'react-bootstrap';
import { decodeJWT } from '../../../../services/candidateService';
import { Badge } from 'react-bootstrap';
import CuratedCandidates from '../curatedCandidates/curatedCandidates';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
const AddClient = (props) => {
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const isAdmin = decoded?.roles === 'ADMIN';
  const isDataEntryTL = decoded?.roles === 'DATA_ENTRY_TL';
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('clientId');
  const loggedInUsername = decoded?.username;

  const isEditMode = Boolean(clientId);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const nav = performance.getEntriesByType("navigation")[0];
  const isBackNav = nav && nav.type === "back_forward";

  const [activeTab, setActiveTab] = useState(() => {
    if (!isBackNav) {
      sessionStorage.removeItem("clientTab");
      return "details";
    }
    return sessionStorage.getItem("clientTab") || "details";
  });


  const [loader, setLoader] = useState(false);
  let [industrySector, setIndustrySector] = useState([]);
  const [industrySubcategories, setIndustrySubcategories] = useState([]);

  let [paymentTypes, setPaymentTypes] = useState([]);
  let [subscriptionTypes, setSubscriptionTypes] = useState([
    {
      subscriptionType: '',
      subscriptionDisplayValue: '--Select--',
    },
  ]);
  let [loadedData, setLoadedData] = useState(null);
  const initialValues = {
    companyName: '',
    industry: '',
    industrySubcategory: "",

    contactPerson: {
      name: '',
      designation: '',
      phoneNumber: '',
      emailId: '',
    },
    address: '',
    pinCodeDetails: {
      state: '',
      district: '',
      pinCode: '',
    },
    gstin: '',

    gstAddressDiffFromCompanyAddress: 'NO',
    gstAddress: '',
    gstAddressPinCodeDetails: {
      state: '',
      district: '',
      pinCode: '',
    },
    juniorProfileOpted: null,
  };
  const [showSubModal, setShowSubModal] = useState(false);
  const [subValues, setSubValues] = useState({
    subscriptionId: '',
    paymentType: '',
    paymentDate: null,
    transactionId: ''
  });


  let isInitialized = false;

  useEffect(() => {
    let isMounted = true;
    async function getData() {
      try {
        setLoader(true);
        if (clientId) {
          const loadedClientData = await ClientService.getClientById(clientId);

          isInitialized = true;
          let clientData = _.get(loadedClientData, 'data.clients[0]');
          clientData.clientDocs = clientData.clientDocs || [];

          if (!clientData.gstAddressDiffFromCompanyAddress) {
            clientData.gstAddressDiffFromCompanyAddress = 'NO';
          }
          if (!Array.isArray(clientData.subscriptions)) {
            clientData.subscriptions = [
              { subscriptionId: "", paymentType: "", paymentDate: null, transactionId: "" }
            ];
          }
          clientData.subscriptions = clientData.subscriptions.map(s => ({
            ...s,
            subscriptionId: s.subscriptionId || s.id || "",
          }));

          _.set(
            clientData,
            "companyAddrPinCode",
            _.get(clientData, "companyAddrPinCodeDetails.pinCode", "")
          );
          _.set(
            clientData,
            "gstAddressPinCode",
            _.get(clientData, "gstAddressPinCodeDetails.pinCode", "")
          );

          if (isMounted) setLoadedData(clientData);
        }

        // ADD THIS
        const data = await MasterDataService.getAllIndustrySectors();
        if (isMounted) setIndustrySector(['--Select--', ...data.data]);

        const subscriptionTypesdata = await MasterDataService.getAllSubscriptionTypes();
        if (isMounted) setSubscriptionTypes([
          {
            subscriptionType: '',
            subscriptionDisplayValue: '--Select--',
          },
          // ...subscriptionTypesdata.data.subscriptions.map(s => ({
          //   subscriptionId: s.id,
          //   subscriptionDisplayValue: s.subscriptionDisplayValue
          // }))
          ...subscriptionTypesdata.data.subscriptions
            .filter(s => s.id !== 4)
            .map(s => ({
              subscriptionId: s.id,
              subscriptionDisplayValue: s.subscriptionDisplayValue
            }))
        ]);

        const paymentTypesdata = await MasterDataService.getAllPaymentTypes();
        if (isMounted) setPaymentTypes(['--Select--', ...paymentTypesdata.data]);

        if (isMounted) setLoader(false);
      } catch (e) {
        if (isMounted) setLoader(false);
      }
    }
    getData();
    return () => { isMounted = false; };
  }, [clientId]);


  const componentRef = useRef(null);

  const handleDownload = async (doc) => {
    try {
      const res = await ClientUserService.downloadFile(doc.path);
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = doc.originalName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      alert(err.response?.data?.message || err.message);
    }
  };

  const openDeleteModal = (doc) => {
    setSelectedDoc(doc);
    setShowDeleteModal(true);
  };

  const confirmDeleteDoc = async () => {
    if (!selectedDoc) return;

    try {
      setLoader(true);

      await ClientService.deleteClientDocument(
        clientId,
        selectedDoc.path
      );

      const updated = await ClientService.getClientById(clientId);
      setLoadedData(updated.data.clients[0]);

      setShowDeleteModal(false);
      setSelectedDoc(null);

      alert("Document deleted successfully");
    } catch (err) {
      alert(err.response?.data?.message || err.message);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Container fluid>
      <Loader show={loader} type="body" stack="vertical" message="Loading Data" />

      <div>
        <Col>
          <Formik
            enableReinitialize="true"
            initialValues={loadedData || initialValues}
            onSubmit={async (values) => {
              const payload = {
                ...values,
                industry: values.industry,
                industrySubcategory: values.industrySubcategory,
                juniorProfileOpted:
                  values.juniorProfileOpted === ''
                    ? null
                    : values.juniorProfileOpted,
              };

              const res = await handleClientSubmission(payload, setLoader, clientId, isEditMode);
              if (!clientId && res?.data?.clients?.[0]?.clientId) {
                const newClientId = res.data.clients[0].clientId;
                window.location.href = `/add-client?clientId=${newClientId}`;
              }
            }}


            validationSchema={AddClientFormValidationSchema}
            validationContext={{ isEditMode }}
            innerRef={componentRef}
            isInitialValid={true}
          >
            {({ values, handleChange, handleBlur, errors, touched, setFieldValue, submitForm, isInitialized }) => {
              useEffect(() => {
                const selectedIndustry = values.industry;
                if (!selectedIndustry) {
                  setIndustrySubcategories([]);
                  setFieldValue("industrySubcategory", "");
                  return;
                }

                const industryObj = industrySector.find(
                  (i) => i.industrySector === selectedIndustry
                );

                if (!industryObj) return;

                MasterDataService.getIndustrySubcategories(industryObj.id)
                  .then((res) => setIndustrySubcategories(res.data || []))
                  .catch(() => setIndustrySubcategories([]));
              }, [values.industry, industrySector]);

              const clientDocsFileRef = useRef(null);



              return (
                <Card style={{ backgroundColor: '#ffffff' }}>
                  <FormikForm className="signite-form">
                    <Card.Body>
                      {window.debug && (
                        <Card>
                          <Card.Body>{JSON.stringify(values)}</Card.Body>
                          <Card.Body>{JSON.stringify(errors)}</Card.Body>
                        </Card>
                      )}

                      <div className="signite-form">
                        {!isDataEntryTL &&
                          ((!clientId && activeTab === 'details') ||

                            // EDIT MODE → submit from details or subscription tab
                            (clientId && (activeTab === 'details' || activeTab === 'subscription'))
                          ) && (
                            <Row className="mb-3">
                              <Col>
                                <SigniteButton
                                  className="float-end"
                                  variant="outline-primary"
                                  style={{ marginLeft: 16, width: 183 }}
                                  onClick={() => window.history.back()}
                                >
                                  Cancel
                                </SigniteButton>
                                <SigniteButton
                                  className="float-end"
                                  variant="primary"
                                  style={{ marginLeft: 16, width: 183 }}
                                  onClick={() => submitForm()}
                                >
                                  {clientId ? 'Update' : 'Submit'}
                                </SigniteButton>
                              </Col>
                            </Row>
                          )}

                        <br />

                        <Tabs activeKey={activeTab} onSelect={(k) => {
                          setActiveTab(k);
                          sessionStorage.setItem("clientTab", k);
                        }}
                          id="client-tabs" className="mb-3"
                        >
                          <Tab
                            eventKey="details" title={
                              <span
                                style={{
                                  color: activeTab === "details" ? "#F35824" : "#2D3E50",
                                  fontWeight: activeTab === "details" ? 600 : 400
                                }}
                              >
                                Client Details
                              </span>
                            }>
                            <Row className="mb-4 g-3">
                              <Col md={4}>
                                <BSForm.Group>
                                  <BSForm.Label>Company Name*</BSForm.Label>
                                  <BSForm.Control
                                    type="text"
                                    name="companyName"
                                    maxLength={50}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={`form-control ${getErrorClass(errors, touched, 'companyName')}`}
                                    value={_.get(values, "companyName")}
                                    disabled={isDataEntryTL}
                                  />
                                  <span className="errorMessage">{getErrorMessage(errors, touched, 'companyName', isInitialized)}</span>
                                </BSForm.Group>
                              </Col>

                              <Col md={4}>
                                <BSForm.Group>
                                  <BSForm.Label>Industry*</BSForm.Label>
                                  <BSForm.Select
                                    name="industry"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.industry}
                                    disabled={isDataEntryTL}
                                    className={`form-control ${getErrorClass(errors, touched, "industry")}`}
                                  >
                                    <option value="">--Select--</option>

                                    {industrySector.map((item) => (
                                      <option key={item.id} value={item.industrySector}>
                                        {item.industrySector}
                                      </option>
                                    ))}
                                  </BSForm.Select>


                                  <span className="errorMessage">{getErrorMessage(errors, touched, 'industry')}</span>
                                </BSForm.Group>
                              </Col>
                              <Col md={4}>
                                <BSForm.Group>
                                  <BSForm.Label>Industry Subcategory</BSForm.Label>

                                  <BSForm.Select
                                    name="industrySubcategory"
                                    value={values.industrySubcategory}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={isDataEntryTL || !values.industry}
                                    className={`form-control ${getErrorClass(errors, touched, 'industrySubcategory')}`}
                                  >
                                    <option value="">--Select--</option>

                                    {industrySubcategories.map((sub) => (
                                      <option key={sub.id} value={sub.subcategory}>
                                        {sub.subcategory}
                                      </option>

                                    ))}

                                  </BSForm.Select>

                                  <span className="errorMessage">
                                    {getErrorMessage(errors, touched, "industrySubcategory")}
                                  </span>
                                </BSForm.Group>
                              </Col>
                            </Row>
                            {!isEditMode && (
                              <>
                                <Row className="mb-4 g-3">
                                  <Col md={4}>
                                    <BSForm.Group>
                                      <BSForm.Label>Contact Person*</BSForm.Label>
                                      <BSForm.Control
                                        type="text"
                                        name="contactPerson.name"
                                        maxLength={50}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={`form-control ${getErrorClass(errors, touched, 'contactPerson.name')}`}
                                        value={_.get(values, "contactPerson.name")}
                                        disabled={isDataEntryTL}

                                      />
                                      <span className="errorMessage">
                                        {getErrorMessage(errors, touched, 'contactPerson.name')}
                                      </span>
                                    </BSForm.Group>
                                  </Col>
                                  <Col md={4}>

                                    <BSForm.Group>
                                      <BSForm.Label>Designation*</BSForm.Label>
                                      <BSForm.Control
                                        type="text"
                                        name="contactPerson.designation"
                                        maxLength={50}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={`form-control ${getErrorClass(errors, touched, 'contactPerson.designation')}`}
                                        value={_.get(values, "contactPerson.designation")}
                                        disabled={isDataEntryTL}

                                      />
                                      <span className="errorMessage">
                                        {getErrorMessage(errors, touched, 'contactPerson.designation')}
                                      </span>
                                    </BSForm.Group>
                                  </Col>
                                  <Col md={4}>
                                    <BSForm.Group>
                                      <BSForm.Label>Contact Number*</BSForm.Label>
                                      <BSForm.Control
                                        type="text"
                                        placeholder='+9194XXXXXXXX'
                                        name="contactPerson.phoneNumber"
                                        maxLength={20}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={`form-control ${getErrorClass(errors, touched, 'contactPerson.phoneNumber')}`}
                                        value={_.get(values, "contactPerson.phoneNumber")}
                                        disabled={isDataEntryTL}

                                      />
                                      <span className="errorMessage">
                                        {getErrorMessage(errors, touched, 'contactPerson.phoneNumber')}
                                      </span>
                                    </BSForm.Group>
                                  </Col>
                                </Row>
                              </>)}
                            {/* {!isEditMode && ( */}
                            <Row className="mb-4 g-3">

                              {!isEditMode && (
                                <Col md={4}>
                                  <BSForm.Group>
                                    <BSForm.Label>Contact Person Email ID*</BSForm.Label>
                                    <BSForm.Control
                                      type="text"
                                      name="contactPerson.emailId"
                                      maxLength={50}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={_.get(values, "contactPerson.emailId")}
                                      disabled={isDataEntryTL}
                                    />
                                  </BSForm.Group>
                                </Col>
                              )}

                              <Col md={4}>
                                <BSForm.Group>
                                  <BSForm.Label>Address*</BSForm.Label>
                                  <BSForm.Control
                                    type="text"
                                    name="address"
                                    value={_.get(values, "address")}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={isDataEntryTL}
                                  />
                                </BSForm.Group>
                              </Col>

                              <Col md={4}>
                                <BSForm.Group>
                                  <BSForm.Label>Pincode*</BSForm.Label>
                                  <BSForm.Control
                                    type="number"
                                    name="companyAddrPinCode"
                                    value={_.get(values, "companyAddrPinCode")}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={isDataEntryTL}
                                  />
                                </BSForm.Group>
                              </Col>

                              {/* 👇 Move GST here in edit mode */}
                              {isEditMode && (
                                <Col md={4}>
                                  <BSForm.Group>
                                    <BSForm.Label>GST Number*</BSForm.Label>
                                    <BSForm.Control
                                      type="text"
                                      name="gstin"
                                      value={_.get(values, "gstin")}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={isDataEntryTL}
                                    />
                                  </BSForm.Group>
                                </Col>
                              )}

                            </Row>
                            {/* )} */}

                            <Row className="mb-4 g-3">
                              {!isEditMode && (
                                <Col md={4}>
                                  <BSForm.Group>
                                    <BSForm.Label>GST Number*</BSForm.Label>
                                    <BSForm.Control
                                      type="text"
                                      name="gstin"
                                      maxLength={20}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      className={`form-control ${getErrorClass(errors, touched, 'gstin')}`}
                                      value={_.get(values, "gstin")}
                                      disabled={isDataEntryTL}

                                    />
                                    <span className="errorMessage">{getErrorMessage(errors, touched, 'gstin')}</span>
                                  </BSForm.Group>
                                </Col>
                              )}
                              <Col md={4}>
                                <BSForm.Group>
                                  <BSForm.Label>Junior Profiles</BSForm.Label>
                                  <BSForm.Select
                                    name="juniorProfileOpted"
                                    value={values.juniorProfileOpted ?? ''}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      setFieldValue(
                                        'juniorProfileOpted',
                                        val === '' ? null : val
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    disabled={isDataEntryTL}
                                  >
                                    <option value="">--Select--</option>
                                    <option value="Y">Yes</option>
                                    <option value="N">No</option>
                                  </BSForm.Select>
                                </BSForm.Group>
                              </Col>
                              <Col md={4}></Col>
                            </Row>

                            <Row>
                              <BSForm.Group as={Col} controlId="gstAddressDiffFromCompanyAddress">
                                <BSForm.Check
                                  className="signite-label"
                                  name="gstAddressDiffFromCompanyAddress"
                                  checked={_.get(values, "gstAddressDiffFromCompanyAddress") === 'YES'}
                                  type="checkbox"
                                  label="Permanent address is different from Current address"
                                  onChange={(el) =>
                                    setFieldValue('gstAddressDiffFromCompanyAddress', el.target.checked ? 'YES' : 'NO')
                                  }
                                  disabled={isDataEntryTL}

                                />
                              </BSForm.Group>
                            </Row>

                            {
                              _.get(values, "gstAddressDiffFromCompanyAddress", "") === 'YES' && (
                                <Row className="mb-3">
                                  <BSForm.Group as={Col}>
                                    <BSForm.Label>Address*</BSForm.Label>
                                    <BSForm.Control
                                      type="text"
                                      name="gstAddress"
                                      maxLength={100}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      className={`form-control ${getErrorClass(errors, touched, 'gstAddress')}`}
                                      value={_.get(values, "gstAddress")}
                                      disabled={isDataEntryTL}

                                    />
                                    <span className="errorMessage">{getErrorMessage(errors, touched, 'gstAddress')}</span>
                                  </BSForm.Group>
                                  <BSForm.Group as={Col}>
                                    <BSForm.Label>Pincode*</BSForm.Label>
                                    <BSForm.Control
                                      type="number"
                                      name="gstAddressPinCode"
                                      min={100000}
                                      max={999999}
                                      onBlur={(e) => {
                                        handlePinChange(
                                          'gstAddressPinCodeDetails',
                                          _.get(values, "gstAddressPinCode"),
                                          setFieldValue
                                        );
                                        handleBlur(e);
                                      }}
                                      onChange={handleChange}
                                      className={`form-control ${getErrorClass(
                                        errors,
                                        touched,
                                        'gstAddressPinCode'
                                      )}`}
                                      value={_.get(values, 'gstAddressPinCode')}
                                      disabled={isDataEntryTL}

                                    />
                                    <span className="errorMessage">
                                      {getErrorMessage(errors, touched, 'gstAddressPinCode')}
                                    </span>
                                    <span className="errorMessage">{`${_.get(values, 'gstAddressPinCodeDetails.district', '') || ''
                                      }${_.get(values, 'gstAddressPinCodeDetails.district', '') ? ',' : ''}${_.get(values, 'gstAddressPinCodeDetails.state', '') || ''
                                      }`}</span>
                                  </BSForm.Group>

                                </Row>
                              )
                            }
                            {isEditMode && (
                              <Row style={{ paddingLeft: 20 }}>
                                <div className="file-upload d-flex align-items-center mb-3">
                                  <BSForm.Group className="mb-0">
                                    <SigniteButton
                                      variant="primary"
                                      onClick={
                                        !isDataEntryTL
                                          ? () => clientDocsFileRef.current.click()
                                          : undefined
                                      }
                                      disabled={isDataEntryTL}
                                    >
                                      Upload Client Document
                                    </SigniteButton>

                                    <input
                                      type="file"
                                      ref={clientDocsFileRef}
                                      style={{ display: 'none' }}
                                      accept=".doc,.docx,.pdf"
                                      onChange={(e) =>
                                        handleClientFileChange(
                                          e,
                                          clientId,
                                          setLoader,
                                          setLoadedData
                                        )
                                      }
                                    />
                                  </BSForm.Group>

                                  <div className="ms-3 mt-2">
                                    {values.clientDocs?.length > 0 ? (
                                      values.clientDocs.map((doc, index) => (
                                        <div key={index} className="d-flex align-items-center mb-1">

                                          <span
                                            style={{ cursor: "pointer", color: "#f35824" }}
                                            onClick={() => handleDownload(doc)}
                                          >
                                            {doc.displayFileName || doc.originalName}
                                          </span>

                                          {!isDataEntryTL && (
                                            <FontAwesomeIcon
                                              icon={faTrash}
                                              style={{
                                                marginLeft: 10,
                                                cursor: "pointer",
                                                color: "red"
                                              }}
                                              onClick={() => openDeleteModal(doc)}
                                            />
                                          )}
                                        </div>
                                      ))
                                    ) : (
                                      <span className="text-muted">No documents uploaded</span>
                                    )}
                                  </div>
                                </div>
                              </Row>
                            )}

                          </Tab>
                          {isEditMode && (
                            <Tab
                              eventKey="contact-person"
                              title={
                                <span
                                  style={{
                                    color: activeTab === "contact-person" ? "#F35824" : "#2D3E50",
                                    fontWeight: activeTab === "contact-person" ? 600 : 400
                                  }}
                                >
                                  Contact Person
                                </span>
                              }
                            >
                              {isEditMode && isAdmin && (
                                <Row className="mb-3">
                                  <Col className="text-end">
                                    <SigniteButton
                                      variant="primary"
                                      className="float-end mb-3"
                                      onClick={async () => {
                                        try {
                                          setLoader(true);
                                          await ClientService.updateContactPerson({
                                            clientId,
                                            ...values.contactPerson
                                          });
                                          alert("Contact Person updated successfully");
                                        } catch (err) {
                                          alert(err.response?.data?.message || err.message);
                                        } finally {
                                          setLoader(false);
                                        }
                                      }}
                                    >
                                      Update Contact Person
                                    </SigniteButton>
                                  </Col>
                                </Row>
                              )}

                              <Row className="mb-4 g-3">
                                <Col md={4}>
                                  <BSForm.Group>
                                    <BSForm.Label>Name</BSForm.Label>
                                    <BSForm.Control
                                      type="text"
                                      name="contactPerson.name"
                                      value={values.contactPerson.name}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={!isAdmin}
                                    />
                                  </BSForm.Group>
                                </Col>

                                <Col md={4}>
                                  <BSForm.Group>
                                    <BSForm.Label>Designation</BSForm.Label>
                                    <BSForm.Control
                                      type="text"
                                      name="contactPerson.designation"
                                      value={values.contactPerson.designation}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={!isAdmin}
                                    />
                                  </BSForm.Group>
                                </Col>

                                <Col md={4}>
                                  <BSForm.Group>
                                    <BSForm.Label>Contact Number</BSForm.Label>
                                    <BSForm.Control
                                      type="text"
                                      name="contactPerson.phoneNumber"
                                      value={values.contactPerson.phoneNumber}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={!isAdmin}
                                    />
                                  </BSForm.Group>
                                </Col>
                              </Row>

                              <Row className="mb-4 g-3">
                                <Col md={4}>
                                  <BSForm.Group>
                                    <BSForm.Label>Email</BSForm.Label>
                                    <BSForm.Control
                                      type="email"
                                      name="contactPerson.emailId"
                                      value={values.contactPerson.emailId}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={!isAdmin}
                                    />
                                  </BSForm.Group>
                                </Col>
                                <Col md={4}></Col>
                                <Col md={4}></Col>
                              </Row>

                            </Tab>
                          )}
                          {isEditMode && (
                            <Tab eventKey="subscription" title={
                              <span
                                style={{
                                  color: activeTab === "subscription" ? "#F35824" : "#2D3E50",
                                  fontWeight: activeTab === "subscription" ? 600 : 400
                                }}
                              >
                                Subscription
                              </span>
                            }>

                              {/* ---------- Edit Mode: Show Add Subscription Button ---------- */}
                              {isAdmin && clientId && (
                                <Row className="mb-3">
                                  <Col>
                                    <SigniteButton
                                      className="float-end"
                                      variant="primary"
                                      onClick={() => setShowSubModal(true)}
                                      style={{
                                        marginTop: 24,
                                        marginBottom: 24,
                                        marginLeft: 16,
                                        width: 183,
                                        lineHeight: "24px",
                                      }}
                                    >
                                      Add Subscription
                                    </SigniteButton>
                                  </Col>
                                </Row>
                              )}


                              {/* ---------- EDIT MODE: READ-ONLY Subscriptions List ---------- */}
                              {clientId &&
                                (values.subscriptions || []).some(
                                  s => s.subscriptionDisplayValue || s.paymentType || s.paymentDate
                                ) && (
                                  <>
                                    {(values.subscriptions || []).map((sub, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          border: "1px solid #ddd",
                                          padding: 12,
                                          marginBottom: 12,
                                          borderRadius: 6,
                                          background: "#fafafa",
                                          position: "relative"

                                        }}
                                      >
                                        {sub.status && (
                                          <Badge
                                            bg={
                                              sub.status === "ACTIVE"
                                                ? "success"
                                                : sub.status === "INACTIVE"
                                                  ? "secondary"
                                                  : "danger"
                                            }
                                            style={{
                                              position: "absolute",
                                              top: 10,
                                              right: 10,
                                              padding: "6px 10px",
                                              fontSize: 12
                                            }}
                                          >
                                            {sub.status}
                                          </Badge>
                                        )}

                                        <p><b>Subscription:</b> {sub.subscriptionDisplayValue}</p>
                                        <p><b>Payment Type:</b> {sub.paymentType}</p>
                                        <p>
                                          <b>Payment Date:</b>{" "}
                                          {sub.paymentDate
                                            ? new Date(sub.paymentDate).toLocaleDateString("en-IN")
                                            : ""}
                                        </p>
                                      </div>
                                    ))}
                                  </>
                                )}

                            </Tab>
                          )}



                          {clientId && (isAdmin || isDataEntryTL) && (
                            <Tab eventKey="curated" title={
                              <span
                                style={{
                                  color: activeTab === "curated" ? "#F35824" : "#2D3E50",
                                  fontWeight: activeTab === "curated" ? 600 : 400
                                }}
                              >Curated Candidates </span>
                            }>
                              <CuratedCandidates clientId={clientId} canManageCuration={isAdmin || decoded?.roles === 'TL'} />
                            </Tab>
                          )}
                        </Tabs>
                        <Row>
                          <Col>
                          </Col>
                        </Row>

                      </div>
                    </Card.Body>
                  </FormikForm>
                </Card>
              );
            }}
          </Formik>
          {/* ---------- Add Subscription Modal (multi-entry) ---------- */}
          <Modal show={showSubModal} onHide={() => setShowSubModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Add Subscriptions</Modal.Title>
            </Modal.Header>

            <Formik
              initialValues={{
                subscriptions: [
                  { subscriptionId: "", paymentType: "", paymentDate: null, transactionId: "" }
                ]
              }}
              onSubmit={async (formValues) => {
                if (!clientId) {
                  alert("Save client before adding subscription");
                  return;
                }

                setLoader(true);

                try {
                  for (let sub of formValues.subscriptions) {
                    await ClientService.addClientSubscription({
                      clientId,
                      subscriptionId: sub.subscriptionId,
                      paymentType: sub.paymentType,
                      paymentDate: sub.paymentDate,
                      transactionId: sub.transactionId || ""
                    });
                  }

                  alert("Subscriptions added");

                  if (componentRef && componentRef.current) {
                    const refreshedClient = await ClientService.getClientById(clientId);
                    const clientData = refreshedClient.data.clients[0];

                    const normalizedSubs = clientData.subscriptions.map(s => ({
                      ...s,
                      subscriptionId: s.id
                    }));

                    componentRef.current.setFieldValue("subscriptions", normalizedSubs);

                  }

                  setShowSubModal(false);
                } catch (err) {
                  alert("Error: " + (err.response?.data?.message || err.message));
                } finally {
                  setLoader(false);
                }
              }}
            >
              {({ values, setFieldValue, handleSubmit }) => (
                <>
                  <Modal.Body>
                    <FieldArray name="subscriptions">
                      {({ push, remove }) => (
                        <>
                          {values.subscriptions.map((sub, index) => (
                            <div
                              key={index}
                              style={{
                                border: "1px solid #ddd",
                                padding: 12,
                                borderRadius: 6,
                                marginBottom: 15
                              }}
                            >
                              <BSForm.Group className="mb-3">
                                <BSForm.Label>Subscription Type *</BSForm.Label>
                                <BSForm.Select
                                  value={sub.subscriptionId}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `subscriptions[${index}].subscriptionId`,
                                      e.target.value
                                    )
                                  }
                                >
                                  {/* <option value="">--Select--</option> */}
                                  {subscriptionTypes.map((s) => (
                                    <option key={s.subscriptionId} value={s.subscriptionId}>
                                      {s.subscriptionDisplayValue}
                                    </option>
                                  ))}
                                </BSForm.Select>
                              </BSForm.Group>

                              <BSForm.Group className="mb-3">
                                <BSForm.Label>Payment Type *</BSForm.Label>
                                <BSForm.Select
                                  value={sub.paymentType}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `subscriptions[${index}].paymentType`,
                                      e.target.value
                                    )
                                  }
                                >
                                  {/* <option value="">--Select--</option> */}
                                  {paymentTypes.map((p) => (
                                    <option key={p} value={p}>
                                      {p}
                                    </option>
                                  ))}
                                </BSForm.Select>
                              </BSForm.Group>

                              <BSForm.Group className="mb-3">
                                <BSForm.Label>Payment Date *</BSForm.Label>
                                <ReactDatePicker
                                  selected={sub.paymentDate}
                                  onChange={(date) =>
                                    setFieldValue(
                                      `subscriptions[${index}].paymentDate`,
                                      date
                                    )
                                  }
                                  dateFormat="dd/MM/yyyy"
                                  maxDate={new Date()}
                                  className="form-control"
                                />
                              </BSForm.Group>

                              {values.subscriptions.length > 1 && (
                                <SigniteButton
                                  variant="outline-danger"
                                  onClick={() => remove(index)}
                                >
                                  Remove
                                </SigniteButton>
                              )}
                            </div>
                          ))}

                          <SigniteButton
                            variant="outline-primary"
                            onClick={() =>
                              push({
                                subscriptionId: "",
                                paymentType: "",
                                paymentDate: null,
                                transactionId: ""
                              })
                            }
                          >
                            + Add another subscription
                          </SigniteButton>
                        </>
                      )}
                    </FieldArray>
                  </Modal.Body>

                  <Modal.Footer>
                    <SigniteButton variant="secondary" onClick={() => setShowSubModal(false)}>
                      Cancel
                    </SigniteButton>

                    <SigniteButton variant="primary" onClick={handleSubmit}>
                      Save All
                    </SigniteButton>
                  </Modal.Footer>
                </>
              )}
            </Formik>
          </Modal>

        </Col>
      </div>

      <Row></Row>
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete this document?
        </Modal.Body>

        <Modal.Footer>
          <Button className="doc-delete-cancel-btn" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button className="doc-delete-confirm-btn" onClick={confirmDeleteDoc}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AddClient;